import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleHolderEditorComponent } from './role-holder-editor/role-holder-editor.component';
import { TranslocoModule } from '@jsverse/transloco';
import { AvatarPillComponent, UserAvatarPipe } from '@frontend/shared';
import { EmailInputFormComponent } from '@frontend/shared';

import { AlertModule } from 'ngx-bootstrap/alert';



@NgModule({
  declarations: [
    RoleHolderEditorComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    AvatarPillComponent,
    EmailInputFormComponent,
    AlertModule,
    UserAvatarPipe,
  ],
  exports: [
    RoleHolderEditorComponent
  ]
})
export class RoleHoldersModule { }
